var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1786 3.30264V4.32329L15.1786 4.52739C19.0042 5.30815 21.8928 8.7122 21.8928 12.7964V13.9347C21.8928 17.0921 23.0474 20.1287 25.1285 22.4874L25.1309 22.4902L25.5735 22.9888C25.5739 22.9894 25.5744 22.9899 25.5748 22.9904C25.7605 23.2025 25.8004 23.4906 25.6914 23.7328C25.5774 23.986 25.333 24.1401 25.0714 24.1401H1.92856C1.66505 24.1401 1.42163 23.9845 1.31054 23.7359C1.2005 23.4896 1.24181 23.2002 1.42472 22.9898C1.42544 22.9889 1.42615 22.9881 1.42687 22.9873L1.86818 22.4912L1.87094 22.488C3.95538 20.1285 5.10713 17.0915 5.10713 13.9347V12.7964C5.10713 8.70557 7.94767 5.30835 11.8185 4.52798L12.8214 4.32578V3.30264V2.14014C12.8214 1.75441 13.1298 1.45264 13.5 1.45264C13.8702 1.45264 14.1786 1.75441 14.1786 2.14014V3.30264ZM13.5 29.9526C12.8059 29.9526 12.143 29.678 11.6558 29.1886C11.4798 29.0118 11.3305 28.8032 11.2118 28.5776H15.7882C15.6695 28.8032 15.5202 29.0118 15.3442 29.1886C14.8634 29.6716 14.1491 29.9526 13.5 29.9526Z",
    stroke: "black",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.fb154119aaf90e8fd037ac364ae2fe8e.svg";
export { ForwardRef as ReactComponent };